// TODO(owner): copy review
export interface Phera {
  number: number;
  name: string;
  meaning: string;
}

export const PHERAS: Phera[] = [
  {
    number: 1,
    name: 'First Phera: Food & Nourishment',
    meaning: 'To provide for a healthy, pure, and prosperous household.',
  },
  {
    number: 2,
    name: 'Second Phera: Strength & Harmony',
    meaning: "To stand together through life's mental, physical, and spiritual challenges.",
  },
  {
    number: 3,
    name: 'Third Phera: Wealth & Prosperity',
    meaning: 'To grow together in wealth, wisdom, and right action.',
  },
  {
    number: 4,
    name: 'Fourth Phera: Family & Happiness',
    meaning: 'To cherish and respect our family, and to nurture our children.',
  },
  {
    number: 5,
    name: 'Fifth Phera: Love & Companionship',
    meaning: 'To remain lifelong partners filled with deep love, trust, and mutual respect.',
  },
  {
    number: 6,
    name: 'Sixth Phera: Health & Long Life',
    meaning: "To care for each other's physical and emotional well-being.",
  },
  {
    number: 7,
    name: 'Seventh Phera: Friendship & Unity',
    meaning: 'To walk together as eternal friends and equals in perfect harmony.',
  },
];
